import { iaRa } from 'lib/helpers/utility';

export const upsertMedicationsLocally = ({ data = {}, formik = {} }) => {
  const dataId = data?.id || data?.tempId;

  const medications = structuredClone(iaRa(formik?.values?.medications));

  if (dataId) {
    formik.setFieldValue(
      'medications',
      medications.map((medication) => {
        const medicationId = medication?.id || medication?.tempId;
        if (medicationId === dataId) {
          return data;
        }

        return medication;
      })
    );
  } else {
    formik.setFieldValue('medications', [...medications, { ...data, tempId: Date.now() }]);
  }
};
